<template>
  <div class="check-account-content">
    <div class="content">
      <ul class="account-card">
        <li>
          <h2>{{cardTitle1}}</h2>
          <h2>数据截至今日</h2>
          <h2>￥{{accountData.rechargeTotal}}</h2>

        </li>
        <li>
          <h2>{{cardTitle2}}</h2>
          <h2>数据截至今日</h2>
          <h2>￥{{accountData.deductTotal}}</h2>
        </li>
        <li>
          <h2>{{cardTitle3}}</h2>
          <h2>数据截至今日</h2>
          <h2>￥{{accountData.balance}}</h2>
          <button @click="switchToRecharge">充值</button>
        </li>
      </ul>

      <el-tabs v-model="activeName" type="border-card" @tab-click="changeActive" style="min-height: 500px">
        <el-tab-pane label="资金明细" name="transactionTab">
          <el-form :inline="true">
            <el-form-item label="交易日期">
              <el-date-picker v-model="transactionDate"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format='yyyy-MM-dd'
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="交易类型">
              <el-select v-model="searchType" placeholder="请选择交易类型">
                <el-option
                  v-for="item in billTypes"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="操作人/检车流水">
              <el-input v-model="searchOperator"
                        placeholder="请输入关键字"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="listTransactions" icon="el-icon-search">查询</el-button>
              <el-button type="primary" @click="restSearch1" >清空</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="transactionList" style="width: 100%" :stripe="true"
            header-row-class-name="psh_table_header" row-class-name="psh_table_row" :border="true">
            <el-table-column
              prop="id"
              label="序号" width="70">
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="交易时间">
            </el-table-column>
            <el-table-column
              label="交易类型">
              <template slot-scope="scope">
                <span v-if="scope.row.transactionType === 'RECHARGE'">充值</span>
                <span v-else-if="scope.row.transactionType === 'REVERSE'">冲正</span>
                <span v-else-if="scope.row.transactionType === 'DEDUCT'">扣费</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="transactionAmount"
              label="交易金额">
            </el-table-column>
            <el-table-column
              prop="afterAmount"
              label="交易后余额">
            </el-table-column>
            <el-table-column
              prop="operator"
              label="操作员/检车流水">
            </el-table-column>
            <el-table-column
              prop="remark"
              label="备注">
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange" style="text-align: right;margin-top: 25px;"
            @current-change="handleCurrentChange"
            :current-page="pageInfo.pageNum"
            :page-sizes="[10, 20, 30, 100]"
            :page-size="pageInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageInfo.total">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="充值历史" name="rechargeList">
          <el-form :inline="true" class="">
            <el-form-item label="充值时间">
              <el-date-picker v-model="rechargeDate" clearable type="daterange" range-separator="至"
                              start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"/>
            </el-form-item>
            <el-form-item label="充值类型">
              <el-select v-model="rechargeChannel" clearable>
                <el-option v-for="channel in channels" :key="channel.value" :label="channel.desc" :value="channel.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="充值状态">
              <el-select v-model="rechargeStatus" clearable>
                <el-option v-for="status in statusList" :key="status.value" :label="status.desc" :value="status.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="流水号">
              <el-input v-model="lsh" placeholder="请输入流水号关键字" clearable/>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="listRecords">查询</el-button>
              <el-button type="primary" @click="restSearch2" >清空</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="records" header-row-class-name="psh_table_header" row-class-name="psh_table_row" :border="true"
                    :stripe="true">
            <el-table-column prop="id" label="序号" width="70"/>
            <el-table-column prop="merchantName" label="检测机构" width="300"/>
            <el-table-column prop="amount" label="充值金额" width="100"/>
            <el-table-column prop="createTime" label="充值时间" width="200"/>
            <el-table-column label="充值类型" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.channel === 1">支付宝扫码</span>
                <span v-else-if="scope.row.channel === 2">支付宝转账</span>
                <span v-else-if="scope.row.channel === 3">银行转账</span>
                <span v-else-if="scope.row.channel === 4">线下充值</span>
              </template>
            </el-table-column>
            <el-table-column label="交易流水" prop="lsh" width="200"/>
            <el-table-column label="充值状态" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.status === 1" style="color: orange">未确认</span>
                <span v-else-if="scope.row.status === 2" style="color: forestgreen">已确认</span>
                <span v-else-if="scope.row.status === 3" style="color: #aaa">已取消</span>
              </template>
            </el-table-column>
            <el-table-column label="充值人" prop="operator">
            </el-table-column>
            <el-table-column label="备注">
              <template slot-scope="scope">
                <span v-if="scope.row.cancelTime">取消时间：{{scope.row.cancelTime}}<br/></span>
                <span v-if="scope.row.cancelReason">取消原因：{{scope.row.cancelReason}}<br/></span>
                <span v-if="scope.row.cancelBy">取消人：{{scope.row.cancelBy}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button v-if="scope.row.status === 1" type="danger" size="small" @click="cancelRecharge(scope.row)">取消</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="快速充值" name="rechargeTab">
          <el-tabs v-model="activeName2">
            <el-tab-pane label="支付宝扫码" name="1" class="saomaContent">
              <div class="sContent active">
                <h3>扫码充值</h3>
                <h2>转账请备注中写明检测机构名称，转账成功后输入充值金额。</h2>
                <img src="../assets/saoma/1.png" alt="" style="width:400px">
                <p>支付宝名称：<span>无锡爬山虎网络科技有限公司(*岩)</span></p>
                <el-form :inline="true" class="confirm_payment_form">
                  <el-form-item label="请输入充值金额">
                    <el-input type="text" v-model="payNum" placeholder="请输入充值金额"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="submitRecharge">确认</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="sContent example">
                <h3>扫码示例</h3>
                <div class="pic_list">
                  <ul>
                    <li>
                      <img  src="../assets/saoma/step1.png" alt="" class="step-icon">
                      <img src="../assets/saoma/2.png"  style="width:467px;" alt="" class="step">
                    </li>
                    <li>
                      <img  src="../assets/saoma/step2.png" alt="" class="step-icon">
                      <img src="../assets/saoma/3.png" alt="" class="step">
                    </li>
                    <li>
                      <img  src="../assets/saoma/step3.png" alt="" class="step-icon">
                      <img src="../assets/saoma/4.png" alt="" class="step">
                    </li>
                    <li>
                      <img  src="../assets/saoma/step4.png" alt="" class="step-icon">
                      <p style="font-size:20px;">
                        <img src="../assets/saoma/ok.png" alt="" style="width:50px;vertical-align:middle;margin-right:10px">充值完成
                      </p>
                    </li>
                  </ul>




                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="支付宝转账" name="2" class="saomaContent">
              <div class="sContent active">
                <h3>转账充值</h3>
                <h2>转账请备注中写明检测机构名称，转账成功后输入充值金额。</h2>
                <img src="../assets/zhifubao/1.png" alt="" style="width:200px">
                <p>支付宝名称：<span>无锡爬山虎网络科技有限公司(*岩)</span></p>
                <p>支付宝账号：<span>wxpashanhu@163.com</span></p>
                <el-form :inline="true" class="confirm_payment_form">
                  <el-form-item label="请输入充值金额">
                    <el-input type="text" v-model="payNum" placeholder="请输入充值金额"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="submitRecharge">确认</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="sContent example">
                <h3>流程示例</h3>
                <div class="pic_list">
                  <img src="../assets/zhifubao/2.png" alt="" class="step"><br>
                  <img src="../assets/saoma/arr.png" alt="" class="arrow_pic"><br>
                  <img src="../assets/zhifubao/3.png" alt="" class="step"><br>
                  <img src="../assets/saoma/arr.png" alt="" class="arrow_pic"><br>
                  <img src="../assets/zhifubao/4.png" alt="" class="step"><br>
                  <img src="../assets/saoma/arr.png" alt="" class="arrow_pic"><br>
                  <img src="../assets/zhifubao/5.png" alt="" class="step"><br>
                  <img src="../assets/saoma/arr.png" alt="" class="arrow_pic"><br>
                  <p style="font-size:20px;">
                    <img src="../assets/saoma/ok.png" alt="" style="width:50px;vertical-align:middle;margin-right:10px">充值完成</p>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="银行转账" name="3" style="padding-bottom:20px">
              <ul class="tips01">
                <li>温馨提示</li>
                <li>1、受银行处理时间影响，采用线下汇款方式到账会有延误。</li>
                <li>2、线下汇款直接向平台的专属账户汇款，系统会将款项直接匹配到您的账户（具体到账时间以银行的实际到账时间为准）。</li>
                <li>3、银行转账充值暂不支持微信和支付宝、财付通等平台转账汇款。</li>
              </ul>
              <ul class="tips02">
                <li>请您通过网银转账，或者自行到银行进行汇款，汇款账号如下：</li>
                <li>开户名称： 无锡爬山虎网络科技有限公司</li>
                <li>开户银行： 中国工商银行股份有限公司无锡吴桥支行</li>
                <li>汇款账号： 1103 0210 0920 0111 794</li>
                <li style="color:red">转账请备注中写明检测机构名称。</li>
              </ul>
              <el-form :inline="true" class="confirm_payment_form">
                <el-form-item label="请输入充值金额">
                  <el-input type="text" v-model="payNum" placeholder="请输入充值金额"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="submitRecharge">确认</el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
      </el-tabs>
    </div>

  </div>
</template>

<script>
  import {
    accountOverview, cancelRecharge,
    createRecharge,
    listRechargeRecords,
    listTransactions
  } from "../modules/services/basic-service";

  export default {
    data() {
      return {
        cardTitle1: '总充值',
        cardTitle2: '总消费',
        cardTitle3: '我的余额',
        accountData: {},
        activeName: 'transactionTab',
        activeName2: '1',
        transactionList: [],
        transactionDate: null,
        searchType: '',
        billTypes: [{
          value: 'RECHARGE',
          text: '充值'
        }, {
          value: 'REVERSE',
          text: '冲正'
        }, {
          value: 'DEDUCT',
          text: '扣费'
        }],
        searchOperator: '',
        pageInfo: {
          pageSize: 10,
          pageNum: 1,
          total: 100
        },
        payNum: '',
        records: [],
        channels: [
          { 'value': 1, 'desc': '支付宝扫码'},
          { 'value': 2, 'desc': '支付宝转账'},
          { 'value': 3, 'desc': '银行转账'},
          { 'value': 4, 'desc': '线下充值'}
        ],
        statusList: [
          {'value': 1, 'desc': '未确认'},
          {'value': 2, 'desc': '已确认'},
          {'value': 3, 'desc': '已取消'}
        ],
        rechargeChannel: '',
        rechargeStatus: '',
        rechargeDate: [],
        lsh: ''
      }
    },
    methods: {
      doSearch() {
        const self = this
        accountOverview().then(({body}) => {
          if (body) {
            self.accountData = body
          }
        })
      },
      listTransactions () {
        const self = this
        let from, to;
        if (self.transactionDate) {
          from = self.transactionDate[0]
          to = self.transactionDate[1]
        }
        listTransactions(this.pageInfo.pageNum, this.pageInfo.pageSize, null, from, to, this.searchType, this.searchOperator).then(({body}) => {
          if (body) {
            self.transactionList = body.data
            self.pageInfo.total = body.total
          }
        })
      },
      cancelRecharge (record) {
        const self = this
        cancelRecharge(record.id).then(({body}) => {
          if (body) {
            self.listRecords()
          }
        })
      },
      submitRecharge () {
        const self = this
        createRecharge(this.payNum, this.activeName2).then(({body}) => {
          if (body) {
            self.activeName = 'rechargeList'
            self.listRecords()
          }
        })
      },
      changeActive(tab) {
        if (tab.name === 'rechargeList') {
          this.listRecords()
        }
      },
      handleSizeChange(val) {
        this.pageInfo.pageSize = val
        this.listTransactions()
      },
      handleCurrentChange(val) {
        this.pageInfo.pageNum = val
        this.listTransactions()
      },
      switchToRecharge () {
        this.activeName = "rechargeTab"
      },
      listRecords () {
        const self = this
        let from = this.rechargeDate ? this.rechargeDate[0] : ''
        let to = this.rechargeDate ? this.rechargeDate[1] : ''
        listRechargeRecords(this.pageInfo.pageNum, this.pageInfo.pageSize, from, to, this.rechargeStatus,
          null, this.rechargeChannel, this.lsh).then(({body}) => {
          self.records = body.data
          self.pageInfo.total = body.total
        })
      },
      restSearch1(){
        console.log(11)
        this.transactionDate=''
        this.searchType=''
        this.searchOperator=''
      },
      restSearch2(){
        this.rechargeDate=''
        this.rechargeStatus=''
        this.rechargeChannel=''
        this.lsh=''
      }
    },
    mounted() {
      this.doSearch()
      this.listTransactions()
      if (this.$route.query.pay) {
        this.activeName = "rechargeTab"
      }
    },



  }
</script>

<style scoped lang='stylus'>
  .check-account-content {
    padding: 5px;
    .account-card {
      border-bottom: 1px dashed #eee;
      margin-bottom 30px
      display: flex;
      flex-wrap: wrap;
      li {
        width: 260px;
        height: 190px;
        line-height: 20px;
        border-radius: 10px;
        box-shadow: 0px 0px 8px 0px rgba(145, 142, 142, 1);
        border: 1px solid rgba(255, 255, 255, 0);
        float left
        margin 0 20px 20px 0
        box-sizing border-box
        padding 20px
        position relative
        list-style none;
        button {
          position absolute
          top 20px
          right 10px
          background #666666
          color white
          width 80px
          height 30px
          border none
          cursor pointer
        }
        h2:first-child {
          color #666363
          font-size 24px
          margin-bottom 15px
        }
        h2:nth-child(2) {
          color #7D7D7D
          font-size 14px
          margin-bottom 25px
        }
        h2:nth-child(3) {
          color #101010
          font-size 36px
          margin-bottom 10px
        }

      }

    }
    .search-input-item {
      margin 0 40px 0 10px
    }
    .search-box {
      margin 30px 0
    }
    .saomaContent {
      display flex
      flex-direction: row
      justify-content: flex-start;
    }
    .sContent {
      border 5px dashed #ccc
      padding 20px 30px
      text-align center
      &.active {
        border-style solid
        margin-right 30px
        width: 500px;
        min-width: 500px;
      }
      &.example {
        width: calc(100% - 530px)
      }
      .pic_list {
        display: flex;
        flex-direction rolw;
        justify-content flex-start
        flex-wrap wrap
        align-items center
        .step {
          border 1px solid #ccc
        }
        .arrow_pic {
          margin: 0 30px
          transform rotate(270deg)
          width: 50px
          height: 50px
        }
        ul li{
          float left
          margin-right 120px
          margin-top 40px
          width 467px
        }
        ul li .step-icon{
          width:100px
          display block
          margin-bottom 20px

        }
      }
      h3 {
        color #101010
        font-weight bold
        margin-bottom 20px
        font-size 24px
        text-align center
      }
      h2 {
        color #E51C23
      }
      p {
        margin 20px 0
        color #101010
        font-weight bold
        span {
          font-weight normal
        }
      }
    }
    .tips01 li, .tips02 li {
      margin-top 25px
      font-size 18px
    }
    .tips01 {
      padding-bottom 30px
      border-bottom 1px solid #eee
      li {
        font-weight bold
      }
      li:last-child {
        color #E51C23
      }
    }
  }
  .confirm_payment_form {
    margin-top: 20px;
    border-top: 1px solid #eee;
    padding-top: 20px;
  }
</style>
<style>
  /* .check-account-content .el-input{
      width: 10%
  } */

</style>